import * as moment from 'moment'
import { Transaction } from './types'

const dayMs = 24 * 60 * 60 * 1000

export const generateIntervalActions = (
  interval: number,
  createdOn: moment.Moment,
  currentDate: moment.Moment
): Transaction[] => {
  const result: Transaction[] = []

  let tmp = new Date(Number(createdOn) + interval * dayMs)
  const cmp = currentDate.toDate()

  while (tmp < cmp) {
    result.push({
      id: String(tmp),
      type: 'INTERVAL_INTEREST',
      createdOn: moment(tmp),
      interval
    })

    tmp = new Date(Number(tmp) + Number(interval * dayMs))
  }

  return result
}

export default generateIntervalActions



// WEBPACK FOOTER //
// ./src/utils/transactions/generateIntervalActions.tsx